// Space - stored and displayed; not used for comparison.
// Hyphen, slash, backslash, dot - stored and displayed; used for comparison after being squashed.
// Letters and numbers - after converting to uppercase, displayed, stored, and used for comparison.
// All other characters along with leading and trailing spaces are discarded.

// Squash procedure: convert all symbols to be squashed into hyphens, and remove consecutive duplicates.

// Examples:
// stored: "00053", fingerprint: "00053" 
// stored: "11 030", fingerprint: "11030"
// stored: "B/10-000.33", fingerprint: "B-10-000-33"
// stored: "gitr-235", fingerprint: "GITR-235"
// stored: "xtreme///", fingerprint: "xtreme-"

// Allowed to be entered and stored in the system
export const serialPattern = /^[0-9A-Z-/\\. ]*$/;
// Not used for comparison
export const nonFingerprintSymbols = /[^0-9A-Z-]/g;
// Symbols to be squashed (converted to a hyphen)
export const squashedSymbols = /[-/\\.]/g;
// Symbols to be removed from both ends of the serial when done editing the field
export const trimmedSymbols = /(^[-/\\. ]+)|([-/\\. ]+$)/g;

export const serialFingerprint = (serial: string) => (serial
  .toUpperCase()
  .replace(squashedSymbols, '-')
  .replace(/-+/g, '-')
  .replace(nonFingerprintSymbols, ''));
  
export const isSerial = (serial: string) => serialPattern.test(serial);
